export default "__VITE_ASSET__B2Ux73Yu__"